import React, { Component, Fragment } from "react";
import { Alert, Button } from "react-bootstrap";
import HtmlParser, { domToReact } from "html-react-parser";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import { get, post } from "../../../utils/DeApi";
import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import DatePicker from "react-datepicker";
import {
  formatDate,
  getNameFromEmail,
  isValidJSON,
  searchAndHighlight,
} from "../../../utils/StringUtils";
import "./FormFiling.scss";
import moment from "moment";
import { years, months } from "../../../utils/CalendarHelpers";
import { getMonth, getYear } from "date-fns";
class FormFiling extends Component {
  constructor(props) {
    super(props);

    this.subscribedPromises = [];
    this.filing = JSON.parse(localStorage.getItem("filing"));
    this.doc = JSON.parse(localStorage.getItem("doc"));
    this.selection = JSON.parse(localStorage.getItem("selection"));
    this.formRef =
      React.createRef(); /* *** reference to the form submit button *** */
    this.timeZone = "America/New_York";
    this.state = {
      /* *** maintaining the state variables for the form fields and data submission *** */
      searchStream: [],
      filingDate: this.dateTransformation(
        moment.tz(this.filing?.filedAt, this.timeZone).format("YYYY-MM-DD")
      ),
      companyName: this.filing?.companyName || "",
      borrowerName: "",
      cikNumber: this.filing?.cik || "",
      filmNumber: this.getFilmNumber() || "",
      ejvId: "",
      ejvDate: "",
      formType: this.filing?.formType || "",
      exhibit: this.selection?.exhibit || "",
      titleName: "",
      agreementType: "-1",
      signingDate: "",
      prevAmendDate: "",
      amendmentNumb: "",
      loanAmount: "",
      bookRunner: "",
      loanExistsLc: "-1",
      lcDealId: "",
      borrowerExistsLc: "-1",
      filingExistsLc: "-1",
      LoanDocNumb: "",
      docCaptureDate: this.dateTransformation(this.selection?.createdAt) || "",
      docUploadDateLC: "",
      filingUrl: this.filing?.linkToHtml || "",
      secUrl: this.getFileUrl() || "",
      recordedAnalystName: getNameFromEmail(this.selection?.email) || "",
      uploadedAnalystName: "",
      filingReviewDate:
        this.dateTransformation(this.selection?.createdAt) || "",
      pixelEdgeComment: "",
      refinitiveComment: "",
      selectionId: this.selection.id || "",
      AnalystId: this.selection.analyst_id || "",
      documentId: this.selection.documentId || "",
      filingId: this.filing?.id || "",
      createError: null,
      IsLoading: false,
      isFocused: false,
      docContents: null,
      searchedDocContents: null,
      docSearch: false,
      error: null,
      show: false,
      variant: "default",
      message: "",
      /* **** adding ML states *** */
      agentScore: 0,
      agreementTypeScore: 0,
      amendmentNumbScore: 0,
      borrowerScore: 0,
      loanAmountScore: 0,
      signingDateScore: 0,
      titleScore: 0,
    };

    this._handle_input_change = this._handle_input_change.bind(this);
    this._handle_date_changed = this._handle_date_changed.bind(this);
    this._handle_submission =
      this._handle_submission.bind(this); /* *** form submission function *** */
    this._handle_submit_click =
      this._handle_submit_click.bind(
        this
      ); /* form submit button binding to the current form element *** */
    this.manageStateData = this.manageStateData.bind(this);
    this.resetAlert = this.resetAlert.bind(this);
    this._handleElementClick = this._handleElementClick.bind(this);
  }

  componentDidMount() {
    this.fetchDocument(); /* *** getting the document from url *** */
    this._fetchFileData(); /* *** checking database for record if exists *** */
    // setTimeout(()=> {
    //   this.stateFeeding(); /* *** getting scoring data ready from selection **** */
    // }, 2000);
  }

  /* *** when click on element it copies the value for search *** */
  _handleElementClick(event) {
    const text = event.target.innerText;
    this.setState({
      searchStream: text ? text : "",
    });
  }

  getColorByScore(score = 0, limit = 0) {
    return score !== 0 && score >= limit
      ? "text-success"
      : score !== 0 && score < limit
      ? "text-warning"
      : score === 0
      ? "text-danger"
      : "";
  }

  manageStateData(data) {
    this.setState((state, props) => {
      let agent_score = 0;
      let agent_name = "";
      let agreement_type_score = 0;
      let agreement_type = "";
      let amend_score = 0;
      let amend_num = "";
      let borrow_score = 0;
      let borrow_name = "";
      let loan_amount_score = 0;
      let loan_amount = 0;
      let sign_date_score = 0;
      let sign_date = "";
      let title_score = 0;
      let title = "";
      const filing_meta =
        data && data.filing_meta !== undefined && data.filing_meta.length > 0
          ? data.filing_meta
          : this.selection.filing_meta;

      // if(data && (data.filing_meta !== undefined) && (data.filing_meta.length > 0)){
      filing_meta?.map((val, index) => {
        let meta_value = isValidJSON(val.meta_value)
          ? JSON.parse(val.meta_value)
          : val.meta_value;
        switch (val?.meta_key) {
          case "agent":
            agent_score =
              Number(val.score) > 0 ? Number(val.score).toFixed(2) : 0;
            agent_name =
              meta_value !== null && typeof meta_value === "object"
                ? meta_value.join("|")
                : meta_value;
            break;
          case "agreement_type":
            agreement_type_score =
              Number(val.score) > 0 ? Number(val.score).toFixed(2) : 0;
            agreement_type = meta_value;

            break;
          case "Amendment number":
            amend_score = val.meta_value !== "" ? 0.5 : 0;
            amend_num = meta_value;
            break;
          case "borrower":
            borrow_score =
              Number(val.score) > 0 ? Number(val.score).toFixed(2) : 0;
            borrow_name =
              meta_value !== null && typeof meta_value === "object"
                ? meta_value.join("|")
                : meta_value;
            break;
          case "loan amount":
            loan_amount_score =
              Number(val.score) > 0 ? Number(val.score).toFixed(2) : 0;
            loan_amount = meta_value;
            break;
          case "signing_date":
            sign_date_score =
              Number(val.score) > 0 ? Number(val.score).toFixed(2) : 0;
            sign_date =
              (meta_value && meta_value !== "") || meta_value !== null
                ? moment(meta_value).format("YYYY-MM-DD")
                : "";
            break;
          case "title":
            title_score =
              Number(val.score) > 0 ? Number(val.score).toFixed(2) : 0;
            title = meta_value;
            break;
          default:
            break;
        }
      });
      // }

      return {
        filingDate:
          data.filing_date &&
          data.filing_date !== "" &&
          data.filing_date !== null
            ? moment(data.filing_date).format("MM-DD-YYYY")
            : moment(this.filing.filedAt).utc().format("MM-DD-YYYY"),
        title_name: data.company_name
          ? data.company_name
          : this.filing.companyName,
        borrowerName: data.borrower_name
          ? data.borrower_name
          : borrow_name
          ? borrow_name
          : "",
        borrowerScore: borrow_score,
        cikNumber: data.cik_number ? data.cik_number : this.filing.cik,
        filmNumber: data.film_number ? data.film_number : this.getFilmNumber(),
        ejvId: data.ejv_id ? data.ejv_id : "",
        ejvDate:
          data.ejv_date && data.ejv_date !== "" && data.ejv_date !== null
            ? this.dateTransformation(data.ejv_date)
            : "",
        formType: data.form_type ? data.form_type : this.filing.formType,
        exhibit: data.exhibit ? data.exhibit : this.selection.exhibit,
        titleName: data.title_name ? data.title_name : title ? title : "",
        titleScore: title_score,
        agreementType: data.agreement_type
          ? data.agreement_type
          : agreement_type
          ? agreement_type
          : "-1",
        agreementTypeScore: agreement_type_score,
        signingDate:
          sign_date !== "" && sign_date !== null
            ? this.dateTransformation(sign_date)
            : data.signing_date !== "" && data.signing_date !== null
            ? this.dateTransformation(data.signing_date)
            : "",
        signingDateScore: sign_date_score,
        prevAmendDate:
          data.prev_amend_date &&
          data.prev_amend_date &&
          data.prev_amend_date !== "" &&
          data.prev_amend_date !== null
            ? this.dateTransformation(data.prev_amend_date)
            : "",
        amendmentNumb: data.amend_numb
          ? data.amend_numb
          : amend_num
          ? amend_num
          : "",
        amendmentNumbScore: amend_score,
        loanAmount: this.currencyFormat(
          this.validate(
            data.loan_amount ? data.loan_amount : loan_amount ? loan_amount : 0
          )
        ),
        loanAmountScore: loan_amount_score,
        bookRunner: data.book_runner
          ? data.book_runner
          : agent_name
          ? agent_name
          : "",
        agentScore: agent_score,
        loanExistsLc: data.loan_exists_lc ? data.loan_exists_lc : "-1",
        lcDealId: data.lc_deal_id ? data.lc_deal_id : "",
        borrowerExistsLc: data.borrower_exists_lc
          ? data.borrower_exists_lc
          : "-1",
        filingExistsLc: data.filing_entry_exists_lc
          ? data.filing_entry_exists_lc
          : "-1",
        LoanDocNumb: data.loan_doc_num ? data.loan_doc_num : "",
        docCaptureDate:
          data.doc_capture_date &&
          data.doc_capture_date !== "" &&
          data.doc_capture_date !== null
            ? this.dateTransformation(data.doc_capture_date)
            : this.dateTransformation(this.selection.createdAt),
        docUploadDateLC:
          (data.doc_upload_lc_date && data.doc_upload_lc_date !== "") ||
          data.doc_upload_lc_date !== null
            ? this.dateTransformation(data.doc_upload_lc_date)
            : "",
        filingUrl:
          data.filing_url !== undefined && data.filing_url !== null
            ? data.filing_url
            : this.filing.linkToHtml,
        secUrl:
          data.sec_url !== undefined && data.sec_url !== null
            ? data.sec_url
            : this.getFileUrl(),
        recordedAnalystName: data.analyst_name_who_recorded
          ? data.analyst_name_who_recorded
          : getNameFromEmail(this.selection.email),
        uploadedAnalystName: data.analyst_name_who_upload
          ? data.analyst_name_who_upload
          : "",
        filingReviewDate:
          data.filing_review_date &&
          data.filing_review_date !== "" &&
          data.filing_review_date !== null
            ? this.dateTransformation(data.filing_review_date)
            : this.dateTransformation(this.selection.createdAt),
        pixelEdgeComment: data.pixeledge_comment ? data.pixeledge_comment : "",
        refinitiveComment: data.refinitive_comment
          ? data.refinitive_comment
          : "",
        selectionId:
          data.selection_id !== undefined && data.selection_id !== null
            ? data.selection_id
            : this.selection.id,
        documentId:
          data.document_id !== undefined && data.document_id !== null
            ? data.document_id
            : this.selection.documentId,
        filingId:
          data.filing_id !== undefined && data.filing_id !== null
            ? data.filing_id
            : this.filing.id,
      };
    });
  }

  componentDidUpdate() {
    // console.log("Yes component updated");
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function (promise) {
      promise.cancel(); /* *** canceling all promises *** */
    });
  }

  getFilmNumber() {
    let film = {};
    if (
      this.filing !== undefined &&
      this.filing !== null &&
      this.filing.entities !== undefined &&
      this.filing.entities !== null
    ) {
      film = this.filing.entities.find((item) =>
        item.cik === this.filing.cik ? item : {}
      );
    }
    return film.filmNo;
  }

  getFileUrl() {
    let doc = "";
    if (
      this.filing !== undefined &&
      this.filing !== null &&
      this.filing.documentFormatFiles !== undefined &&
      this.filing.documentFormatFiles !== null
    ) {
      doc = this.filing.documentFormatFiles.find((item) =>
        item.documentId === this.selection.documentId ? item.documentId : 0
      );
    }
    return doc.documentUrl;
  }

  _handle_input_change(val, whichIndex = "") {
    switch (whichIndex) {
      case "companyName":
        this.setState((state, props) => {
          return { companyName: val.target.value };
        });
        break;

      case "borrowerName":
        this.setState((state, props) => {
          return { borrowerName: val.target.value };
        });
        break;

      case "cikNumber":
        this.setState((state, props) => {
          return { cikNumber: val.target.value };
        });
        break;

      case "filmNumber":
        this.setState((state, props) => {
          return { filmNumber: val.target.value };
        });
        break;

      case "ejvId":
        this.setState((state, props) => {
          return { ejvId: val.target.value };
        });
        break;

      case "formType":
        this.setState((state, props) => {
          return { formType: val.target.value };
        });
        break;

      case "exhibit":
        this.setState((state, props) => {
          return { exhibit: val.target.value };
        });
        break;

      case "titleName":
        this.setState((state, props) => {
          return { titleName: val.target.value };
        });
        break;

      case "agreementType":
        this.setState((state, props) => {
          return { agreementType: val.target.value };
        });
        break;

      case "amendmentNumb":
        this.setState((state, props) => {
          return { amendmentNumb: val.target.value };
        });
        break;

      case "loanAmount":
        this.setState((state, props) => {
          return { loanAmount: this.validate(val.target.value) };
        });
        break;

      case "bookRunner":
        this.setState((state, props) => {
          return { bookRunner: val.target.value };
        });
        break;

      case "loanExistsLc":
        this.setState((state, props) => {
          return { loanExistsLc: val.target.value };
        });
        break;

      case "lcDealId":
        this.setState((state, props) => {
          return { lcDealId: val.target.value };
        });
        break;

      case "borrowerExistsLc":
        this.setState((state, props) => {
          return { borrowerExistsLc: val.target.value };
        });
        break;

      case "filingExistsLc":
        this.setState((state, props) => {
          return { filingExistsLc: val.target.value };
        });
        break;

      case "LoanDocNumb":
        this.setState((state, props) => {
          return { LoanDocNumb: val.target.value };
        });
        break;

      case "filingUrl":
        this.setState((state, props) => {
          return { filingUrl: val.target.value };
        });
        break;

      case "secUrl":
        this.setState((state, props) => {
          return { secUrl: val.target.value };
        });
        break;

      case "recordedAnalystName":
        this.setState((state, props) => {
          return { recordedAnalystName: val.target.value };
        });
        break;

      case "uploadedAnalystName":
        this.setState((state, props) => {
          return { uploadedAnalystName: val.target.value };
        });
        break;

      case "pixelEdgeComment":
        this.setState((state, props) => {
          return { pixelEdgeComment: val.target.value };
        });
        break;

      case "refinitiveComment":
        this.setState((state, props) => {
          return { refinitiveComment: val.target.value };
        });
        break;
      default:
        break;
    }
  }

  _handle_date_changed(date, whichIndex = "") {
    // const date = d.target.value;
    switch (whichIndex) {
      case "filingDate":
        this.setState((state, props) => {
          return { filingDate: this.dateTransformation(date) };
        });
        break;

      case "ejvDate":
        this.setState((state, props) => {
          return { ejvDate: this.dateTransformation(date) };
        });
        break;

      case "signingDate":
        this.setState((state, props) => {
          return { signingDate: this.dateTransformation(date) };
        });
        break;

      case "prevAmendDate":
        this.setState((state, props) => {
          return { prevAmendDate: this.dateTransformation(date) };
        });
        break;

      case "docCaptureDate":
        this.setState((state, props) => {
          return { docCaptureDate: this.dateTransformation(date) };
        });
        break;

      case "docUploadDateLC":
        this.setState((state, props) => {
          return { docUploadDateLC: this.dateTransformation(date) };
        });
        break;

      case "filingReviewDate":
        this.setState((state, props) => {
          return { filingReviewDate: this.dateTransformation(date) };
        });
        break;
      default:
        break;
    }
  }

  _handle_submission(event) {
    event.preventDefault();
    const {
      filingDate,
      companyName,
      borrowerName,
      cikNumber,
      filmNumber,
      ejvId,
      ejvDate,
      formType,
      exhibit,
      titleName,
      agreementType,
      signingDate,
      prevAmendDate,
      amendmentNumb,
      loanAmount,
      bookRunner,
      loanExistsLc,
      lcDealId,
      borrowerExistsLc,
      filingExistsLc,
      LoanDocNumb,
      docCaptureDate,
      docUploadDateLC,
      filingUrl,
      secUrl,
      recordedAnalystName,
      uploadedAnalystName,
      filingReviewDate,
      pixelEdgeComment,
      refinitiveComment,
      documentId,
      selectionId,
      filingId,
    } = this.state;

    const submissionPromise = post("/saveFilingData", {
      filing_date: this.sqlFriendlyDate(filingDate),
      company_name: companyName,
      document_id: documentId,
      selection_id: selectionId,
      filing_id: filingId,
      borrower_name: borrowerName,
      cik_number: cikNumber,
      film_number: filmNumber,
      ejv_id: ejvId,
      ejv_date: this.sqlFriendlyDate(ejvDate),
      form_type: formType,
      exhibit: exhibit,
      title_name: titleName,
      agreement_type: agreementType,
      signing_date: this.sqlFriendlyDate(signingDate),
      prev_amend_date: this.sqlFriendlyDate(prevAmendDate),
      amend_numb: amendmentNumb,
      loan_amount: this.validate(loanAmount),
      book_runner: bookRunner,
      loan_exists_lc: loanExistsLc,
      lc_deal_id: lcDealId,
      borrower_exists_lc: borrowerExistsLc,
      filing_entry_exists_lc: filingExistsLc,
      loan_doc_num: LoanDocNumb,
      doc_capture_date: this.sqlFriendlyDate(docCaptureDate),
      doc_upload_lc_date: this.sqlFriendlyDate(docUploadDateLC),
      filing_url: filingUrl,
      sec_url: secUrl,
      analyst_name_who_recorded: recordedAnalystName,
      analyst_name_who_upload: uploadedAnalystName,
      filing_review_date: this.sqlFriendlyDate(filingReviewDate),
      pixeledge_comment: pixelEdgeComment,
      refinitive_comment: refinitiveComment,
    });
    submissionPromise.promise
      .then((resp) => {
        if (resp.success !== false) {
          this.setState({
            IsLoading: false,
            show: true,
            variant: "success",
            message: "Data submitted successfully!",
          });
          // window.close();
        } else if (resp.success !== true) {
          this.setState({
            createError: resp.error,
            IsLoading: false,
            variant: "danger",
            message: resp.error,
            show: true,
          });
        }
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({
            createError: error,
            IsLoading: false,
            variant: "danger",
            message: error,
            show: true,
          });
      });
    event.preventDefault();
    this.subscribedPromises.push(submissionPromise);
  }

  _handle_submit_click() {
    if (this.formRef.current) {
      this._handle_submission({ preventDefault: () => {} });
    }
  }

  /* *** change date format to SQL friendly ( below ) *** */
  sqlFriendlyDate(date) {
    return date ? moment(date).format("YYYY-MM-DD") : "";
  }

  _fetchFileData() {
    const { selectionId, analystId, documentId } = this.state;
    const fetchPromise = get("/fetchFilingData", {
      params: {
        selection_id: selectionId,
        analyst_id: analystId,
        document_id: documentId,
      },
    });
    fetchPromise.promise
      .then((response) => {
        this.manageStateData(
          response.data
        ); /* *** setting the states here *** */
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({
            createError: error,
            IsLoading: false,
          });
      });
    this.subscribedPromises.push(fetchPromise);
  }

  fetchDocument() {
    this.setState({ error: null, IsLoading: true });
    let filed_at = "";

    if (this.filing.filedAt.includes("T")) {
      // Date is in ISO 8601 format
      filed_at = this.filing.filedAt.split("T").shift();
    } else {
      // Date is in simple date format
      filed_at = this.filing.filedAt;
    }

    let documentUrl =
      "https://dealsense-filing.s3.us-west-2.amazonaws.com/" +
      filed_at +
      "/" +
      this.filing.accessionNo +
      "/" +
      this.doc.documentUrl.split("/").pop();

    axios
      .get(documentUrl)
      .then((response) => {
        this.setState({
          docContents: this.parseHTML(response.data),
          searchedDocContents: this.parseHTML(response.data),
          error: null,
          IsLoading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.fetchDocumentLegacy();
      });
  }

  fetchDocumentLegacy() {
    this.setState({ docContents: null, error: null, IsLoading: true });
    // const { doc, filing } = this.state;

    const fetchDocumentPromise = get(
      `filings/${this.filing.accessionNo}/document`,
      {
        params: { type: this.doc.type.trim() },
      }
    );

    fetchDocumentPromise.promise
      .then((response) => {
        this.setState({
          docContents: this.parseHTML(response.data),
          error: null,
          IsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, IsLoading: false });
      });
  }

  parseHTML(html) {
    const options = {
      replace: ({ name, children, attribs }) => {
        if (name === "font") {
          return (
            <font style={{ fontSize: 12 }}>
              {domToReact(children, options)}
            </font>
          );
        }

        if (name === "a") {
          return (
            <a
              href={`https://www.sec.gov/Archives/edgar/data/${
                this.filing.cik
              }/${this.filing.accessionNo.replace(/-/gi, "")}/${attribs.href}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {domToReact(children, options)}
            </a>
          );
        }

        if (name === "img") {
          return (
            <img
              alt={attribs.alt || this.filing.accessionNo}
              src={`https://www.sec.gov/Archives/edgar/data/${
                this.filing.cik
              }/${this.filing.accessionNo.replace(/-/gi, "")}/${attribs.src}`}
            />
          );
        }
      },
    };

    try {
      return ReactDOMServer.renderToString(HtmlParser(html, options));
    } catch (e) {
      return html;
    }
  }

  /* *** validate user input for numeric value ( below ) *** */
  validate(s) {
    let charRegex = /^[A-Za-z]+$/;
    let validated = 0;
    if (s !== undefined && s !== null && s !== "") {
      s = s.toString().trim();
      if (!s.match(charRegex)) {
        s = s.replace("$", "");
        validated = s.replace(/,/g, "");
      }
    }
    return validated;
  }

  /* *** check if an element is in focus ( below ) *** */
  _handleFocus(focus, val, field = "general") {
    const { searchStream, docContents, searchedDocContents } = this.state;

    let searched = "";

    /* *** date field searching *** */
    if (val === "date") {
      searched = formatDate(
        new Date(field.target.value !== "" ? field.target.value : null)
      );
    } else if (val === "borrower" || val === "leads") {
      searched = field.target.value.split("|");
    } else {
      searched = val.target.value;
    }

    this.setState({
      searchedDocContents: null,
    });
    if (focus) {
      this.setState(
        {
          searchStream: searched,
        },
        () => {
          let matched = searchAndHighlight(
            docContents,
            Array.prototype.concat(searched)
          );
          this.setState({
            searchedDocContents: matched,
          });
        }
      );
    } else {
      this.setState({
        searchStream: "",
        searchedDocContents: null,
      });
    }
    this.setState({
      isFocused: focus,
    });
    if (this.state.isFocused) {
      this.setState((state, props) => {
        return {
          loanAmount: this.currencyFormat(this.validate(this.state.loanAmount)),
        };
      });
    }
  }

  /* *** transform the numeric value into currency format ( below ) *** */
  currencyFormat(val) {
    let currency = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0, // (For whole numbers, it will print 2500.10 as $2,500.1)
      maximumFractionDigits: 2, // (It will round-off 2500.99 to $2,501)
    });
    return currency.format(parseFloat(val));
  }

  /* *** datepicker ( custom ) *** */
  datePicker(selectedDate, whichIndex, class_name = "") {
    // selectedDate = new Date(selectedDate);

    return (
      <>
        <DatePicker
          portalId="root-portal"
          className={`form-control roundedEdges ${class_name}`}
          dayClassName={() => {
            return "text-dark";
          }}
          onChange={(date) => {
            this._handle_date_changed(date, whichIndex);
          }}
          onFocus={this._handleFocus.bind(this, true, "date")}
          placeholderText="MM/DD/YYYY"
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => (
            <div
              style={{ margin: 10, display: "flex", justifyContent: "center" }}
            >
              <button
                type="button"
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
              >
                {" "}
                {"<"}{" "}
              </button>
              <select
                value={getYear(date)}
                onChange={({ target: { value } }) => changeYear(value)}
              >
                {years.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <select
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
              >
                {" "}
                {">"}{" "}
              </button>
            </div>
          )}
          selected={
            selectedDate !== undefined &&
            selectedDate !== "" &&
            selectedDate !== null
              ? new Date(selectedDate)
              : ""
          }
        />
      </>
    );
  }

  /* *** date format transformation ( below ) *** */
  dateTransformation(dateObj) {
    // return  dateObj!== null ? moment(dateObj).format("MM-DD-YYYY") : '';
    // moment.tz(dateObj, this.timeZone)
    if (dateObj !== undefined && dateObj !== null && dateObj !== "") {
      const date = moment(dateObj);
      return date.isValid() ? date.format("MM-DD-YYYY") : "";
    }
    return "";
  }

  /* *** Dynamic alert ( below ) *** */
  bsAlert(variant, message) {
    return (
      <Alert
        variant={variant}
        id="alert-deal-style-animation"
        className="alert-deal-style animate-deal-alert deal-alert-left"
        onClose={() => this.resetAlert()}
        dismissible
      >
        <p>
          <strong>{message}</strong>
        </p>
      </Alert>
    );
  }

  /* *** close handler for Bootstrap-Alert ( below ) *** */
  resetAlert() {
    this.setState({
      show: !this.state.show,
      variant: "default",
      message: "",
    });
  }

  render() {
    const {
      docContents,
      searchedDocContents,
      show,
      message,
      variant,
      error,
      filingDate,
      companyName,
      borrowerName,
      IsLoading,
      cikNumber,
      filmNumber,
      ejvId,
      ejvDate,
      formType,
      exhibit,
      titleName,
      agreementType,
      signingDate,
      prevAmendDate,
      amendmentNumb,
      loanAmount,
      bookRunner,
      loanExistsLc,
      lcDealId,
      borrowerExistsLc,
      filingExistsLc,
      LoanDocNumb,
      docCaptureDate,
      docUploadDateLC,
      filingUrl,
      secUrl,
      recordedAnalystName,
      uploadedAnalystName,
      filingReviewDate,
      pixelEdgeComment,
      refinitiveComment,
      agentScore,
      agreementTypeScore,
      amendmentNumbScore,
      borrowerScore,
      loanAmountScore,
      signingDateScore,
      titleScore,
    } = this.state;
    // const { onDocumentClosed, onCatalogueAdd } = this.props;
    if (IsLoading) return <Loader />;

    return (
      <Fragment>
        <div className="row" id="form-fields-page">
          {/* Document view card ( below ) */}
          <div className="col-md-9">
            {/* adding a card to display document (below) */}
            <div className="card documentViewControl scrollControl">
              <div className="card-body h-50">
                <span className="card-title h2">
                  {this.filing?.companyName},{" "}
                  <strong variant="info">{this.doc?.type}</strong>
                </span>
                <hr />
                <div className="card-text">
                  {IsLoading && <Loader />}
                  {error && <ErrorHandler error={error} />}
                  {docContents && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          searchedDocContents !== null
                            ? searchedDocContents
                            : docContents,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>{" "}
            {/* *** End card starting div *** */}
          </div>{" "}
          {/* *** End col-md-9 div *** */}
          <div className="col-md-3 scrollControl documentViewControl formSection">
            <form onSubmit={this._handle_submission} ref={this.formRef}>
              <div className="form-group">
                {/* Filing Date */}
                <label htmlFor="filing_date_id">Filing Date</label>
                {/* <input className="form-control roundedEdges" onChange={(date) => {this._handle_date_changed(date, 'filingDate') }}   id="filing_date_id" name="filing_date"  placeholder="Date" type="date"  value={filingDate || this.state.filingDate} /> */}
                <div className="filing-field">
                  {/* <DatePicker dateFormat="MM/dd/yyyy" placeholderText="Filing Date" className="form-control roundedEdges" value={filingDate || this.state.filingDate} onChange={(date) => {this._handle_date_changed(date, 'filingDate') }}   /> */}
                  {this.datePicker(filingDate, "filingDate")}
                </div>
              </div>
              <div className="form-group">
                {/* Company Filing name */}
                <label htmlFor="company_name_id">Company Filing Name</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="company_name_id"
                  name="company_name"
                  value={companyName}
                  onChange={(val) => {
                    this._handle_input_change(val, "companyName");
                  }}
                  placeholder="Company Filing Name"
                />
              </div>
              <div className="form-group">
                {/* Borrower name */}
                <label
                  htmlFor="borrower_name_id"
                  className={this.getColorByScore(borrowerScore, 0.5)}
                >
                  Borrower Name
                </label>
                {/* <input className="form-control roundedEdges" type="text" id="borrower_name_id" name="borrower_name" value={borrowerName} onChange={(val) => {this._handle_input_change(val, 'borrowerName')}} placeholder="Borrower Name" /> */}
                <textarea
                  id="borrower_name_id"
                  name="borrower_name"
                  onFocus={this._handleFocus.bind(this, true, "borrower")}
                  className={`form-control roundedEdges ${this.getColorByScore(
                    borrowerScore,
                    0.5
                  )}`}
                  placeholder="Borrower Name"
                  rows={3}
                  value={borrowerName}
                  onChange={(val) => {
                    this._handle_input_change(val, "borrowerName");
                  }}
                ></textarea>
                <p>
                  <span
                    className={this.getColorByScore(borrowerScore, 0.5)}
                  >{`Score: ${borrowerScore}`}</span>
                </p>
              </div>
              <div className="form-group">
                {/* CIK number */}
                <label htmlFor="cik_number_id">CIK Number</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="cik_number_id"
                  name="cik_number"
                  value={cikNumber}
                  onChange={(val) => {
                    this._handle_input_change(val, "cikNumber");
                  }}
                  placeholder="CIK Number"
                />
              </div>
              <div className="form-group">
                {/* Film number */}
                <label htmlFor="film_number_id">Film Num</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="film_number_id"
                  name="film_number"
                  value={filmNumber}
                  onChange={(val) => {
                    this._handle_input_change(val, "filmNumber");
                  }}
                  placeholder="Film Num"
                />
              </div>
              <div className="form-group">
                {/* EJV-ID */}
                <label htmlFor="ejv_id">EJV ID</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="ejv_id"
                  name="ejvId"
                  value={ejvId}
                  onChange={(value) => {
                    this._handle_input_change(value, "ejvId");
                  }}
                  placeholder="EJV ID"
                />
              </div>
              <div className="form-group">
                {/* EJV-ID-Date */}
                <label htmlFor="ejv_date_id">
                  Date EJV ID was re-checked to the BLUES
                </label>
                {/* <input className="form-control roundedEdges" type="date" id="ejv_date_id" name="ejv_date" value={ejvDate} placeholder="Date EJV ID was re-checked to the BLUES" onChange={(date) => {this._handle_date_changed(date, 'ejvDate') }} /> */}
                <div className="filing-field">
                  {/* <DatePicker   dateFormat="MM/dd/yyyy" placeholderText="MM/DD/YYYY" className="form-control roundedEdges" value={ejvDate} onChange={(date) => {this._handle_date_changed(date, 'ejvDate') }}   /> */}
                  {this.datePicker(ejvDate || "", "ejvDate")}
                </div>
              </div>
              <div className="form-group">
                {/* Form-type */}
                <label htmlFor="form_type_id">Form Type</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="form_type_id"
                  name="form_type"
                  value={formType}
                  onChange={(val) => {
                    this._handle_input_change(val, "formType");
                  }}
                  placeholder="Form Type"
                />
              </div>
              <div className="form-group">
                {/* Exhibits */}
                <label htmlFor="exhibit_id">Exhibit</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="exhibit_id"
                  name="exhibit"
                  value={exhibit}
                  onChange={(val) => {
                    this._handle_input_change(val, "exhibit");
                  }}
                  placeholder="Exhibit"
                />
              </div>
              <div className="form-group">
                {/* Title Name */}
                <label
                  htmlFor="title_name"
                  className={this.getColorByScore(titleScore, 0.5)}
                >
                  Title Name
                </label>
                <input
                  className={`form-control roundedEdges ${this.getColorByScore(
                    titleScore,
                    0.5
                  )}`}
                  type="text"
                  id="title_name"
                  name="title_name"
                  value={titleName}
                  onChange={(val) => {
                    this._handle_input_change(val, "titleName");
                  }}
                  onFocus={this._handleFocus.bind(this, true)}
                  placeholder="Title Name"
                  autoComplete="on"
                />
                <p>
                  <span className={this.getColorByScore(titleScore, 0.5)}>
                    {`Score: ${titleScore}`}
                  </span>
                </p>
              </div>
              <div className="form-group">
                {/* Agreement Type */}
                <label
                  htmlFor="agreement_type_id"
                  className={`${this.getColorByScore(agreementTypeScore, 0.8)}`}
                >
                  Agreement Type (O, A, A&R, Warrant or Waiver)
                </label>
                <select
                  className={`form-control roundedEdges customSelect ${this.getColorByScore(
                    agreementTypeScore,
                    0.8
                  )}`}
                  id="agreement_type_id"
                  value={agreementType}
                  onChange={(val) => {
                    this._handle_input_change(val, "agreementType");
                  }}
                  name="agreement_type"
                  placeholder="Agreement Type (O, A, A&R, Warrant or Waiver)"
                >
                  <option value={"-1"}>Select</option>
                  <option value={"Origination"}>Origination</option>
                  <option value={"Amendment"}>Amendment</option>
                  <option value={"A&R"}>A&R</option>
                  <option value={"Press Release"}>Press Release</option>
                  <option value={"Draft"}>Draft</option>
                </select>
                <p>
                  <span
                    className={this.getColorByScore(agreementTypeScore, 0.8)}
                  >{`Score: ${agreementTypeScore}`}</span>
                </p>
              </div>
              <div className="form-group">
                {/* Signing Date */}
                <label
                  htmlFor="signing_date_id"
                  className={this.getColorByScore(signingDateScore, 0.8)}
                >
                  Signing Date
                </label>
                {/* <input className="form-control roundedEdges" type="date" placeholder="Signing Date" id="signing_date_id" name="signing_date" value={signingDate} onChange={(date) => {this._handle_date_changed(date, 'signingDate') }}   /> */}
                <div className="filing-field">
                  {/* <DatePicker placeholderText="MM/DD/YYYY"  dateFormat="MM/dd/yyyy" className="form-control roundedEdges" value={signingDate} onChange={(date) => {this._handle_date_changed(date, 'signingDate') }}   /> */}
                  {this.datePicker(
                    signingDate,
                    "signingDate",
                    this.getColorByScore(signingDateScore, 0.8)
                  )}
                </div>
                <span
                  className={this.getColorByScore(signingDateScore, 0.8)}
                >{`Score: ${signingDateScore}`}</span>
              </div>
              <div className="form-group">
                {/* Previous Amendment Date */}
                <label htmlFor="prev_amend_date_id">
                  Previous Date being Amended
                </label>
                {/* <input className="form-control roundedEdges" type="date" id="prev_amend_date_id" name="prev_amend_date" placeholder="Previous Date being Amended"  value={prevAmendDate} onChange={(date) => {this._handle_date_changed(date, 'prevAmendDate') }}/> */}
                <div className="filing-field">
                  {/* <DatePicker placeholderText="MM/DD/YYYY"  dateFormat="MM/dd/yyyy" className="form-control roundedEdges" value={prevAmendDate} onChange={(date) => {this._handle_date_changed(date, 'prevAmendDate') }}   /> */}
                  {this.datePicker(prevAmendDate, "prevAmendDate")}
                </div>
              </div>
              <div className="form-group">
                {/* Amendment Number */}
                <label
                  htmlFor="prev_amend_date_id"
                  className={this.getColorByScore(amendmentNumbScore, 0.5)}
                >
                  Amendment number
                </label>
                <input
                  className={`form-control roundedEdges ${this.getColorByScore(
                    amendmentNumbScore,
                    0.5
                  )}`}
                  type="text"
                  id="amend_num_id"
                  value={amendmentNumb}
                  onChange={(val) => {
                    this._handle_input_change(val, "amendmentNumb");
                  }}
                  name="amend_numb"
                  placeholder="Amendment number"
                />
                <p>
                  <span
                    className={this.getColorByScore(amendmentNumbScore, 0.5)}
                  >
                    {`Score: ${amendmentNumbScore}`}
                  </span>
                </p>
              </div>
              <div className="form-group">
                {/* Loan Amount */}
                <label
                  htmlFor="loan_amount_id"
                  className={this.getColorByScore(loanAmountScore, 0.5)}
                >
                  Loan $$ Amount (only needed for O, A/R)
                </label>
                <input
                  className={`form-control roundedEdges ${this.getColorByScore(
                    loanAmountScore,
                    0.5
                  )}`}
                  type="text"
                  id="loan_amount_id"
                  name="loan_amount"
                  value={loanAmount}
                  onChange={(val) => {
                    this._handle_input_change(val, "loanAmount");
                  }}
                  onBlur={this._handleFocus.bind(this, false)}
                  onFocus={this._handleFocus.bind(this, true)}
                  min={0}
                  placeholder="Loan $$ Amount (only needed for O, A/R)"
                />
                <p>
                  <span className={this.getColorByScore(loanAmountScore, 0.5)}>
                    {`Score: ${loanAmountScore}`}
                  </span>
                </p>
              </div>
              <div className="form-group">
                {/* Book Runner */}
                <label
                  htmlFor="book_runner"
                  className={this.getColorByScore(agentScore, 0.5)}
                >
                  Lead Arranger/Bookrunner
                </label>
                <input
                  className={`form-control roundedEdges ${this.getColorByScore(
                    agentScore,
                    0.5
                  )}`}
                  onFocus={this._handleFocus.bind(this, true, "leads")}
                  type="text"
                  id="book_runner"
                  name="book_runner"
                  value={bookRunner}
                  onChange={(val) => {
                    this._handle_input_change(val, "bookRunner");
                  }}
                  placeholder="Lead Arranger/Bookrunner"
                  autoComplete="on"
                />
                <span
                  className={this.getColorByScore(agentScore, 0.5)}
                >{`Score: ${agentScore}`}</span>
              </div>
              <div className="form-group">
                {/* Loan Exists */}
                <label htmlFor="loan_exists_id">
                  Does Loan Exist in Loan Connector
                </label>
                <select
                  className="form-control roundedEdges customSelect"
                  id="loan_exists_id"
                  value={loanExistsLc}
                  onChange={(val) => {
                    this._handle_input_change(val, "loanExistsLc");
                  }}
                  name="loan_exists_lc"
                  placeholder="Does Loan Exist in Loan Connector"
                >
                  <option value={"-1"}>Select</option>
                  <option value={"0"}>No</option>
                  <option value={"1"}>Yes</option>
                </select>
              </div>
              <div className="form-group">
                {/* Loan Connector Dael Id */}
                <label htmlFor="lc_deal_Id_of_id">Loan Connector Deal ID</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="lc_deal_Id_of_id"
                  value={lcDealId}
                  onChange={(val) => {
                    this._handle_input_change(val, "lcDealId");
                  }}
                  name="lc_deal_id"
                  placeholder="Loan Connector Deal ID"
                />
              </div>
              <div className="form-group">
                {/* Borrower Exists */}
                <label htmlFor="borrower_exists_id">
                  Does Borrower Exist in Loan Connector?
                </label>
                <select
                  className="form-control roundedEdges customSelect"
                  id="borrower_exists_id"
                  name="borrower_exists_lc"
                  value={borrowerExistsLc}
                  onChange={(val) => {
                    this._handle_input_change(val, "borrowerExistsLc");
                  }}
                  placeholder="Does Borrower Exist in Loan Connector?"
                >
                  <option value={"-1"}>Select</option>
                  <option value={"0"}>No</option>
                  <option value={"1"}>Yes</option>
                </select>
              </div>
              <div className="form-group">
                {/* Filing Entry Exists Loan Connector */}
                <label htmlFor="filing_entry_exists_lc_id">
                  Does Filing Entity exist in Loan Connector?
                </label>
                <select
                  className="form-control roundedEdges customSelect"
                  id="filing_entry_exists_lc_id"
                  name="filing_entry_exists_lc"
                  value={filingExistsLc}
                  onChange={(val) => {
                    this._handle_input_change(val, "filingExistsLc");
                  }}
                  placeholder="Does Filing Entity exist in Loan Connector?"
                >
                  <option value={"-1"}>Select</option>
                  <option value={"0"}>No</option>
                  <option value={"1"}>Yes</option>
                </select>
              </div>
              <div className="form-group">
                {/* Loan Doc # */}
                <label htmlFor="loan_doc_num_id">Loan Doc #</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="loan_doc_num_id"
                  name="loan_doc_num"
                  placeholder="Loan Doc #"
                  value={LoanDocNumb}
                  onChange={(val) => {
                    this._handle_input_change(val, "LoanDocNumb");
                  }}
                />
              </div>
              <div className="form-group">
                {/* Document Capture Date */}
                <label htmlFor="doc_capture_date_id">
                  Date document was captured from SEC
                </label>
                {/* <input className="form-control roundedEdges" type="date" id="doc_capture_date_id" name="doc_capture_date" placeholder="Date document was captured from SEC" value={docCaptureDate} onChange={(date) => {this._handle_date_changed(date, 'docCaptureDate') }} /> */}
                <div className="filing-field">
                  {/* <DatePicker placeholderText="MM/DD/YYYY"  dateFormat="MM/dd/yyyy" className="form-control roundedEdges" value={docCaptureDate} onChange={(date) => {this._handle_date_changed(date, 'docCaptureDate') }}   /> */}
                  {this.datePicker(docCaptureDate, "docCaptureDate")}
                </div>
              </div>
              <div className="form-group">
                {/* Upload Document Date to Loan Connector */}
                <label htmlFor="doc_upload_lc_date_id">
                  Date doc was uploaded to Loan Connector
                </label>
                {/* <input className="form-control roundedEdges" type="date" id="doc_upload_lc_date_id" name="doc_upload_lc_date" placeholder="Date doc was uploaded to Loan Connector"  value={docUploadDateLC} onChange={(date) => {this._handle_date_changed(date, 'docUploadDateLC') }} /> */}
                <div className="filing-field">
                  {/* <DatePicker placeholderText="MM/DD/YYYY"  dateFormat="MM/dd/yyyy" className="form-control roundedEdges" value={docUploadDateLC} onChange={(date) => {this._handle_date_changed(date, 'docUploadDateLC') }}   /> */}
                  {this.datePicker(docUploadDateLC, "docUploadDateLC")}
                </div>
              </div>
              <div className="form-group">
                {/* Filing URL */}
                <label htmlFor="filing_url_id">Filing URL</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="filing_url_id"
                  name="filing_url"
                  placeholder="Filing URL"
                  value={filingUrl}
                  onChange={(val) => {
                    this._handle_input_change(val, "filingUrl");
                  }}
                />
              </div>
              <div className="form-group">
                {/* SEC URL */}
                <label htmlFor="sec_url_id">SEC.gov URL</label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="sec_url_id"
                  name="sec_url"
                  placeholder="SEC.gov URL"
                  value={secUrl}
                  onChange={(val) => {
                    this._handle_input_change(val, "secUrl");
                  }}
                />
              </div>
              <div className="form-group">
                {/* Analyst who recorded document */}
                <label htmlFor="analyst_name_who_recorded_id">
                  Analyst who recorded the document
                </label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="analyst_name_who_recorded_id"
                  name="analyst_name_who_recorded"
                  placeholder="Analyst who recorded the document"
                  value={recordedAnalystName}
                  onChange={(val) => {
                    this._handle_input_change(val, "recordedAnalystName");
                  }}
                />
              </div>
              <div className="form-group">
                {/* Uploading Analyst to Loan Connector */}
                <label htmlFor="analyst_name_who_upload_id">
                  Analyst who uploaded the document to Loan Connector
                </label>
                <input
                  className="form-control roundedEdges"
                  type="text"
                  id="analyst_name_who_upload_id"
                  name="analyst_name_who_upload"
                  placeholder="Analyst who uploaded the document to Loan..."
                  value={uploadedAnalystName}
                  onChange={(val) => {
                    this._handle_input_change(val, "uploadedAnalystName");
                  }}
                />
              </div>
              <div className="form-group">
                {/* Filing Review Date */}
                <label htmlFor="filing_review_date_id">
                  Date the filing was reviewed in Loan Connector for company
                  presence
                </label>
                {/* <input className="form-control roundedEdges" type="text" id="filing_review_date_id" name="filing_review_date" placeholder="Date the filing was reviewed in Loan Connector for company presence"  value={filingReviewDate} onChange={(date) => {this._handle_date_changed(date, 'filingReviewDate') }} /> */}
                <div className="filing-field">
                  {/* <DatePicker placeholderText="MM/DD/YYYY"  dateFormat="MM/dd/yyyy" className="form-control roundedEdges" value={filingReviewDate} onChange={(date) => {this._handle_date_changed(date, 'filingReviewDate') }}   /> */}
                  {this.datePicker(filingReviewDate, "filingReviewDate")}
                </div>
              </div>
              <div className="form-group">
                {/* PixelEdge Comment textBox */}
                <label htmlFor="pixeledge_comment_id">PixelEdge Comment</label>
                <textarea
                  id="pixeledge_comment_id"
                  name="pixeledge_comment"
                  className="form-control roundedEdges"
                  placeholder="PixelEdge Comment"
                  rows={3}
                  value={pixelEdgeComment}
                  onChange={(val) => {
                    this._handle_input_change(val, "pixelEdgeComment");
                  }}
                ></textarea>
              </div>
              <div className="form-group">
                {/* Refinitive Comment textBox */}
                <label htmlFor="refinitive_comment_id">Refinitiv Comment</label>
                <textarea
                  id="refinitive_comment_id"
                  name="refinitive_comment"
                  className="form-control roundedEdges"
                  placeholder="Refinitive Comment"
                  rows={3}
                  value={refinitiveComment}
                  onChange={(val) => {
                    this._handle_input_change(val, "refinitiveComment");
                  }}
                ></textarea>
              </div>
            </form>
          </div>{" "}
          {/* End div col-md-3 */}
        </div>{" "}
        {/* End row div */}
        <div className="form-group submissionBtn">
          <Button
            variant="defaul"
            className="btn-success-deal-style roundedEdges w-100"
            onClick={this._handle_submit_click}
            type="button"
          >
            {" "}
            Submit{" "}
          </Button>
          {/* *** alert for showing action status ( below ) *** */}
          {show && this.bsAlert(variant, message)}
        </div>
      </Fragment>
    );
  }
}

export default FormFiling;
